import { useContext, useEffect, useState } from 'react';

import { FetchHookState } from './types/FetchHookState';
import { environmentContext } from '../../../environmentContext/environmentContext';
import { ClearingAccountValidationStatusForCompany } from '../../../types/ClearingAccountValidationStatusForCompany';

export type UseFetchClearingAccountStatusForCompanyState = FetchHookState<ClearingAccountValidationStatusForCompany[]>;

const defaultState: UseFetchClearingAccountStatusForCompanyState = {
  data: [],
  loading: true,
};

export const useFetchClearingAccountValidationStatus = (integrationType?: string) => {
  const [fetchHookState, setFetchHookState] = useState<UseFetchClearingAccountStatusForCompanyState>(defaultState);
  const services = useContext(environmentContext);
  useEffect(() => {
    if (!integrationType) return;
    setFetchHookState(defaultState);
    services.ValidationApiClient.fetchClearingAccountValidationStatus(integrationType)
      .then((data) => {
        setFetchHookState({
          data,
          loading: false,
        });
      })
      .catch((error) => {
        setFetchHookState({
          data: [],
          error,
          loading: false,
        });
      });
  }, [services, integrationType]);
  return fetchHookState;
};
